





































import {Component, Mixins} from 'vue-property-decorator';
import {
    ColumnRetrieveResponse, CommonModelUtils, SyncR3StudyListInfo, SyncR3StudySelectDialogRequest, TableHeader
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SystemApi from '@/api/SystemApi';
import CommonApi from '@/api/CommonApi';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';
import MessageUtils from '@/utils/MessageUtils';

@Component({
    components: {TextInput, CommonPromptDialog, CommonPaginatedTable, CommonButton, IconButton},
    mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin]
})
export default class SyncR3StudySelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin) {
    private readonly menuId: string = 'MU-CI-ST';
    private readonly columnIds: string[] = [
        'STD_SPN_NO',
        'STD_NAME',
        'RPT_GIV_NAME',
        'RPT_QUALIFY'
    ];
    
    private values: SyncR3StudyListInfo[] = [];
    private onSelect: ($event: any, row: SyncR3StudyListInfo) => void;
    
    get getValues() {
        return this.values;
    }
    
    get isLoading() {
        return this.loading;
    }
    
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('syncR3StudySelectDialog', (params: SyncR3StudySelectDialogRequest) => {
                this.width = params.width ? params.width : this.DEFAULT_WIDTH;
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideSyncR3StudySelectDialog', () => this.onCancel());
    }
    
    public show(request: SyncR3StudySelectDialogRequest) {
        this.visible = true;
        this.onSelect = request.onSelect;
        
        this.retrieve(1, 10);
    }
    
    public onRowClick(data: any) {
        const {row, $event} = data;
        
        if (this.onSelect) {
            this.onSelect($event, row);
        }
        
        this.onCancel();
    }
    
    public retrieve(pageNo: number, rowCount: number) {
        this.loading = true;
        return Promise.all([
                          this.getColumnRetrievePromise(),
                          SystemApi.retrieveR3Studies(this.$route.params.companyKey, {pageNo, rowCount, keyword: this.keyword})
                      ])
                      .then((values: any[]) => {
                          if (!values[0].success) {
                              return Promise.reject(values[0].errMsg);
                          }
                          const columns = CommonModelUtils.getOrDefault(values[0].data, {columnList: []}).columnList
                                                          .filter(((column: TableHeader) => this.columnIds.includes(column.columnId)));
                          this.columns = this.initializeColumns(columns);

                          if (!values[1].success) {
                              return Promise.reject(values[1].errMsg);
                          }
                          const paginate = CommonModelUtils.getOrDefaultPaginate(values[1].data);
                          this.values = paginate.listInfo;
                          this.pageInfo = paginate.pageInfo;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg))
                      .finally(() => this.loading = false);
    }
    
    private getColumnRetrievePromise(): Promise<ColumnRetrieveResponse> {
        if (this.columns && this.columns.length > 0) {
            return Promise.resolve({
                data: {
                    columnList: this.columns
                },
                success: true
            });
        }
        return CommonApi.retrieveColumns(this.menuId);
    }
    
    public onCancel() {
        this.visible = false;
    }
    
    public afterClosed() {
        this.values = [];
        this.keyword = '';
        this.loading = false;
    }
    
    public destroyed() {
        this.$modal.getEventBus().$off('syncR3StudySelectDialog');
        this.$modal.getEventBus().$off('hideSyncR3StudySelectDialog');
    }
}
